import React, { Component } from 'react';
import classes from './DurexIcon.css';
import classNames from 'classnames';

let stout=null;
class DurexIcon extends Component {


	state = {
		hover:false
	};

	
	onComponentWillUnmount = () => {
		//console.log(stout);
		window.clearTimeout(stout);
	}

	mouseIn = event => {
		this.setState({hover:true});
	}

	mouseOut = () => {
		/*
		stout = setTimeout(()=>{
			if (this) {
				this.setState({hover:false});
			}
		},1500);
		*/
		//console.log(stout);
	}

	animationsArray = [
		'jello',
		'wobble',
		'tada',
		'swing',
		'shake',
		'rubberBand',
		'bounce'
	]

	render () {
		
		const iconStyle = {
			left: this.props.x+'%',
			top: this.props.y+'%',
			width: this.props.size+'vw',
			/*
			WebkitAnimationDelay: delay+'s',
			animationDelay: delay+'s',
			animationIterationCount: 'infinite',
			WebkitAnimationIterationCount: 'infinite'
			*/
			//background: "url("+this.props.img+")",
			//background: "url("+this.props.svg+"), linear-gradient(transparent, transparent)"
		}

		const randomAnim = this.animationsArray[Math.floor(this.animationsArray.length*Math.random())];

		return (
			<div 
				className={this.state.hover ? classNames(classes.DurexIcon, randomAnim, 'animated') : classNames(classes.DurexIcon)} 
				style={iconStyle}
				onMouseEnter={this.mouseIn}
				onMouseLeave={this.mouseOut}
			>
				<img src={this.props.img} alt="" className={classes.iconImage} />
				<img src={this.props.svg} alt="" className={classes.iconImage} />				
			</div>
		);
	}
};

export default DurexIcon;


// WEBPACK FOOTER //
// ./src/components/DurexIcon/DurexIcon.js